import { LinkButton } from '@etg/wings';
import { Icon } from '@eti/components';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import EditButton from './SummaryEditSeatButton';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const selectSeatStyles = css`
  align-items: center;
  display: flex;
  gap: 10px;
  margin-right: 4px;
  padding: 8px;

  [dir='rtl'] & {
    margin-left: 4px;
    margin-right: 0;
  }
`;
const cellStyles = css`
  bottom: 0;
  position: absolute;
  right: 0;
  top: 0;

  [dir='rtl'] & {
    left: 0;
    right: auto;
  }

  @media (min-width: 48em) {
    position: static;
    width: 24%;
  }
`;
const actionsWrapperStyles = css`
  display: flex;
  height: 100%;

  @media (min-width: 48em) {
    justify-content: flex-end;
  }
`;
const dataTestId = (button, boundIndex, segmentIndex, travelerIndex) => `seatMapSummaryActionsCell-bound-${boundIndex}-segment-${segmentIndex}-traveler-${travelerIndex}-${button}-button`;
const SummaryActionsCell = _ref => {
  let {
    boundIndex,
    onRemoveSeat,
    onToggleSeatSelect,
    segmentIndex,
    selectedSeat,
    travelerIndex
  } = _ref;
  const {
    t
  } = useTranslation();
  const editLabel = selectedSeat && selectedSeat.seatPreference ? t('Product.SeatMap.Summary.SeatPreference.Change') : t('Product.SeatMap.Summary.Seat.Change');
  const removeLabel = t('Product.SeatMap.Summary.Seat.Remove');
  const selectLabel = t('Product.SeatMap.Seat.Select');
  return /*#__PURE__*/_jsx("td", {
    className: cellStyles,
    children: /*#__PURE__*/_jsx("div", {
      className: actionsWrapperStyles,
      children: selectedSeat && Object.keys(selectedSeat).length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(EditButton, {
          dataTestId: dataTestId('edit', boundIndex, segmentIndex, travelerIndex),
          iconType: "edit",
          label: editLabel,
          onClick: onToggleSeatSelect
        }, "editButton"), /*#__PURE__*/_jsx(EditButton, {
          dataTestId: dataTestId('remove', boundIndex, segmentIndex, travelerIndex),
          iconType: "remove",
          label: removeLabel,
          onClick: onRemoveSeat
        }, "removeButton")]
      }) : /*#__PURE__*/_jsxs(LinkButton, {
        className: selectSeatStyles,
        "data-testid": dataTestId('selectSeat', boundIndex, segmentIndex, travelerIndex),
        onClick: onToggleSeatSelect,
        children: [/*#__PURE__*/_jsx(Icon, {
          color: "currentColor",
          id: "plus-circle-thin",
          size: "1rem"
        }), selectLabel]
      }, "selectSeatButton")
    })
  });
};
export default SummaryActionsCell;
//# sourceMappingURL=SummaryActionsCell.js.map